<template>
  <div class="tc-container">
    <div class="tc-chart">
      <div ref="myChart" class="myChart"></div>
    </div>
    <div class="tc-title">
      {{ item.name }}
    </div>
  </div>
</template>
<script>
  export default {
    props: {
      item: {
        type: Object,
        default() {
          return {}
        },
      },
    },
    data() {
      return {}
    },
    mounted() {
      this.init()
    },
    methods: {
      init() {
        let chartDom = this.$refs.myChart
        let myChart = this.$echarts.init(chartDom)
        let option = (option = {
          title: {
            text: this.item.number,
            subtext: '',
            x: 'center',
            y: 'center',
            textStyle: {
              color: '#fff',
              fontSize: 26,
              fontWeight: 'normal',
            },
          },
          legend: {
            x: 'center',
            y: 'bottom',
            data: ['rose3', 'rose5', 'rose6', 'rose7', 'rose8'],
          },
          series: [
            {
              name: '面积模式',
              type: 'pie',
              radius: [48, 52],
              center: ['50%', '50%'],
              labelLine: {
                show: false,
              },
              data: [
                {
                  value: this.item.number,
                  itemStyle: {
                    color: new this.$echarts.graphic.LinearGradient(
                      0,
                      1,
                      0,
                      0,
                      [
                        {
                          offset: 0,
                          color: this.item.color[0],
                        },
                        {
                          offset: 1,
                          color: this.item.color[1],
                        },
                      ]
                    ),
                  },
                },
                {
                  value: this.item.total - this.item.number,
                  name: 'rose2',
                  itemStyle: {
                    color: '#272A2C',
                  },
                },
              ],
              itemStyle: {
                borderRadius: 20,
              },
            },
          ],
        })
        myChart.setOption(option)
        window.addEventListener('resize', () => {
          myChart.resize()
        })
      },
    },
  }
</script>
<style lang="scss" scoped>
  .tc-container {
    width: 100%;

    .tc-chart {
      width: 6vw;
      height: 6vw;
      margin: 0 auto;

      .myChart {
        width: 6vw;
        height: 6vw;
      }
    }

    .tc-title {
      margin-top: 0.88541vw;
      color: #e6e6e6;
      text-align: center;
      font-size: 14px;
    }
  }
</style>
